const financialStatus = [
  { label: "Lower middle class", value: "Lower middle class" },
  { label: "Middle Class", value: "Middle Class" },
  { label: "Upper Middle Class", value: "Upper Middle Class" },
  { label: "Affluent / Upper Class", value: "Affluent / Upper Class" },
];
export default financialStatus;
